const actions = {
  /**
   * Fetch the invite list.
   *
   * @param commit
   * @param $http
   * @returns {Promise<void>}
   */
  async fetchInviteList({ commit, rootState: { $http } }) {
    const { data } = await $http.get('/admin-invite/');

    commit('setInvites', data);
  },

  /**
   * Resend invite.
   *
   * @param $http
   * @param id
   * @returns {Promise<void>}
   */
  async resendInvite({ rootState: { $http } }, { id }) {
    await $http.post(`/admin-invite/${id}/resend`);
  },

  /**
   * Store the invite.
   *
   * @param $http
   * @param form
   * @returns {Promise<any>}
   */
  async storeInvite({ rootState: { $http } }, { form }) {
    const { data } = await $http.post('/admin-invite', form);

    return data;
  },
};

export default actions;
